import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import React from 'react'

import { useGetWebsiteCategoriesQuery } from '@/generated/graphql'

import { WebSiteList } from './websites.component'
import s from './websites.module.less'

export const WebsitesContainer = () => {
  const { data, loading } = useGetWebsiteCategoriesQuery({
    variables: {
      categoryPagination: {
        last: 1000, // 一次取所有网站分类
      },
      pagination: {
        last: 1000, // 一次获取所有网站
      },
    },
  })

  const categories = data ? data.website.categories.edges.slice().map(({ node }) => node) : []

  return (
    <div className={s.container}>
      {loading && <div className={s.mask} />}
      {loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} className={s.spin} />}
      <div className={s.content}>
        {categories.map((category) => (
          <WebSiteList key={category.websiteCategoryId} websiteCategory={category} loading={loading} />
        ))}
      </div>
    </div>
  )
}
